<template>
  <div class="turntable-detail">
    <div class="light_box">
      <div class="prize_box">
        <ul class="light_top">
          <li v-for="n in 18" :key="'t' + n"></li>
        </ul>
        <ul class="light_bottom">
          <li v-for="n in 18" :key="'b' + n"></li>
        </ul>
        <ul class="light_left">
          <li v-for="n in 13" :key="'l' + n"></li>
        </ul>
        <ul class="light_right">
          <li v-for="n in 13" :key="'r' + n"></li>
        </ul>
        <ul class="play">
          <li class="prize" :class="{ select: currentIndex == 0 }">
            <div>
              <span><img src="~@/img/turntable/Red.jpg" alt="" /></span>
              <p>红包58</p>
            </div>
            <div class="msk"></div>
          </li>
          <li class="prize" :class="{ select: currentIndex == 1 }">
            <div>
              <span><img src="~@/img/turntable/Coupon.jpg" alt="" /></span>
              <p>5%充值券</p>
            </div>
            <div class="msk"></div>
          </li>
          <li class="prize" :class="{ select: currentIndex == 2 }">
            <div>
              <span><img src="~@/img/turntable/Red.jpg" alt="" /></span>
              <p>随机</p>
            </div>
            <div class="msk"></div>
          </li>
          <li class="prize" :class="{ select: currentIndex == 3 }">
            <div>
              <span><img src="~@/img/turntable/Airpod.jpg" alt="" /></span>
              <p>AIRPOD</p>
            </div>
            <div class="msk"></div>
          </li>
          <li class="prize p-a" :class="{ select: currentIndex == 4 }">
            <div>
              <span><img src="~@/img/turntable/Coupon.jpg" alt="" /></span>
              <p>30%充值券</p>
            </div>
            <div class="msk"></div>
          </li>
          <li class="ex p-a">
            <div class="account">
              <b>剩余<em class="blod">{{ todayState.count }}</em>次</b>
            </div>
            <div class="msk"></div>
          </li>
          <li class="prize p-a" :class="{ select: currentIndex == 5 }">
            <div>
              <span><img src="~@/img/turntable/Firework.jpg" alt="" /></span>
              <p>感谢参与</p>
            </div>
            <div class="msk"></div>
          </li>
          <li class="prize p-a" :class="{ select: currentIndex == 6 }">
            <div>
              <span><img src="~@/img/turntable/iPhone 16.jpg" alt="" /></span>
              <p>新款苹果手机</p>
            </div>
            <div class="msk"></div>
          </li>
          <li class="ex p-a">
            <a id="btn" href="javascript:;" @click="countdown()" v-if="todayState.count > 0">参与抽奖</a>
          </li>
          <li class="prize p-a" :class="{ select: currentIndex == 7 }">
            <div>
              <span><img src="~@/img/turntable/gift.jpg" alt="" /></span>
              <p>幸运盲盒</p>
            </div>
            <div class="msk"></div>
          </li>
          <li class="prize p-a" :class="{ select: currentIndex == 8 }">
            <div>
              <span><img src="~@/img/turntable/Coupon.jpg" alt="" /></span>
              <p>10%充值券</p>
            </div>
            <div class="msk"></div>
          </li>
          <li class="prize p-a" :class="{ select: currentIndex == 9 }">
            <div>
              <span><img src="~@/img/turntable/PS5.jpg" alt="" /></span>
              <p>SONY PS5</p>
            </div>
            <div class="msk"></div>
          </li>
          <li class="prize p-a" :class="{ select: currentIndex == 10 }">
            <div>
              <span><img src="~@/img/turntable/Red.jpg" alt="" /></span>
              <p>随机</p>
            </div>
            <div class="msk"></div>
          </li>
          <li class="prize p-a" :class="{ select: currentIndex == 11 }">
            <div>
              <span><img src="~@/img/turntable/Red.jpg" alt="" /></span>
              <p>888</p>
            </div>
            <div class="msk"></div>
          </li>
        </ul>
      </div>
    </div>

    <div class="mask1" v-show="showLayer">
      <div class="modal1">
        <span class="close1" @click="showLayer = false"></span>
        <div class="win_c">
          <div class="img">
            <img src="~@/img/turntable/Red.jpg" alt="" v-show="currentIndex == 0" />
            <img src="~@/img/turntable/Coupon.jpg" alt="" v-show="currentIndex == 1" />
            <img src="~@/img/turntable/Red.jpg" alt="" v-show="currentIndex == 2" />
            <img src="~@/img/turntable/Airpod.jpg" alt="" v-show="currentIndex == 3" />
            <img src="~@/img/turntable/Coupon.jpg" alt="" v-show="currentIndex == 4" />
            <img src="~@/img/turntable/Firework.jpg" alt="" v-show="currentIndex == 5" />
            <img src="~@/img/turntable/iPhone 16.jpg" alt="" v-show="currentIndex == 6" />
            <img src="~@/img/turntable/gift.jpg" alt="" v-show="currentIndex == 7" />
            <img src="~@/img/turntable/Coupon.jpg" alt="" v-show="currentIndex == 8" />
            <img src="~@/img/turntable/PS5.jpg" alt="" v-show="currentIndex == 9" />
            <img src="~@/img/turntable/Red.jpg" alt="" v-show="currentIndex == 10" />
            <img src="~@/img/turntable/Red.jpg" alt="" v-show="currentIndex == 11" />
            <p v-if="currentIndex != 2 && currentIndex != 10">{{ indexDataTips[currentIndex] }}</p>
            <p v-if="currentIndex == 2 || currentIndex == 10">{{ seletedAmount }}元</p>
          </div>
          <p v-show="currentIndex == 5">谢谢惠顾</p>
          <div class="win_s" v-show="currentIndex != 5">
            系统已自动将实物折扣发放至您的账户，无流水要求。如需更换为实物奖励，请联系客服扣除奖金并兑换。
          </div>
        </div>
      </div>
    </div>

    <div class="rulesbox">
      <h1>幸运大抽奖</h1>
      <div class="c">
        2025年6月1日起<br />
        <span>每天登录签到，完成每日存款要求，即可开始幸运大抽奖，更有机会获得意外礼物.</span>
      </div>
      <div class="rules">
        <h2>每日任务</h2>
        <div class="tj">
          <p>当日APP登录</p>
          <p>当日单笔存款&gt;1000 [当日奖励最多3次]</p>
        </div>
        <h2>活动条款</h2>
        <p class="rule">
          1. 所有会员完成任务 就有机会参与幸运大抽奖，每日抽奖0:00开始，抽奖次数0:00重置；<br />
          2.如当前存款已享有其他充值优惠则不能奖励抽奖次数，获得抽奖机会需于当日使用完毕<br />
          3.登录APP奖励需是充值会员才可以参与；<br />
          4.如抽中礼品请当日联系线上客服协助领取，抽中的礼品可兑换奖金；<br />
          5.获得充值券/奖金券需于当天使用，如未使用视同放弃；充值券可于任意平台完成1倍流水后即可出款，充值卷赠送上限188，奖金券可于任意平台完成5倍流水后即可提款
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { dailyBonus, appDailyBonus } from '../api';

export default {
  name: 'TurntablePromo',
  data() {
    return {
      currentIndex: -1,
      seletedIndex: -1,
      seletedAmount: 0,
      timer: null,
      isOk: true,
      todayState: {
        count: 0,
        betAmount: 0
      },
      countData: {
        loginCount: 0,
        depositCount: 0,
        spCount: 0
      },
      indexDataTips: [
        '红包58',
        '5%充值券',
        '随机红包',
        'AIRPOD',
        '30%充值券',
        '感谢参与',
        '新款苹果手机',
        '新运盲盒',
        '10%充值券',
        '索尼PS5',
        '随机红包',
        '红包888'
      ],
      showLayer: false
    };
  },
  created() {
    this.dailyBonusAsync();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    countdown() {
      if (this.isOk === false || this.todayState.count === 0) {
        return;
      }

      this.isOk = false;

      this.timer = setInterval(() => {
        if (this.currentIndex == 11) {
          this.currentIndex = 0;
        } else {
          this.currentIndex++;
        }

        if (this.currentIndex == this.seletedIndex) {
          this.reset(true);
        }
      }, 100);

      this.appDailyBonusAsync();
    },
    async dailyBonusAsync() {
      const result = await dailyBonus();
      if (!result.Message) {
        this.todayState.count = result.Result.totalCount;
        this.countData.loginCount = result.Result.loginCount;
        this.countData.depositCount = result.Result.depositCount;
        this.countData.spCount = result.Result.spCount;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async appDailyBonusAsync() {
      const result = await appDailyBonus();
      if (!result.Message) {
        setTimeout(() => {
          this.seletedIndex = result.Result.index;
          this.seletedAmount = result.Result.bonus;
        }, 3000);
      } else {
        this.$toast.fail(result.Message);
        this.reset(false);
      }
    },
    reset(successed) {
      clearInterval(this.timer);
      this.isOk = true;
      this.seletedIndex = -1;

      if (successed === true) {
        this.showLayer = true;
        this.todayState.count--;
      }
    }
  }
};
</script>

<style scoped>
.turntable-detail {
  width: 100%;
  max-width: 100%;
  margin-top: 0.24rem;
  box-sizing: border-box;
  padding: 3.6rem 0.24rem 0.24rem;
  border-radius: 0.16rem;
  overflow: hidden;
  background-color: #060c2d;
  background-image: url('~@/img/PC_LP.jpg');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100% auto;
}

.turntable-detail ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

.turntable-detail a {
  text-decoration: none;
}

.turntable-detail .p-a {
  position: absolute !important;
}

.light_box {
  height: 6.9rem;
  width: 7.2rem;
  margin: 0.4rem auto;
  background: linear-gradient(164.05deg, #4547ff 0%, #b423ce 100%);
  border-radius: 0.2rem;
  padding: 0.25rem 0.2rem;
  position: relative;
}

.prize_box {
  width: 100%;
  height: 100%;
  border-radius: 0.2rem;
  padding: 0.14rem 0.17rem;
  background: linear-gradient(164.05deg, #4547ff 0%, #b423ce 100%);
  box-shadow: 0 0 3px 1px #ffa2f9, inset 0 0 5px 3px rgba(0, 0, 0, 0.2);
}

.light_box ul[class^='light_'] {
  display: flex;
  position: absolute;
  justify-content: space-between;
}

.light_box ul[class^='light_'] li {
  display: block;
  width: 0.12rem;
  height: 0.12rem;
  background: #fde466;
  border-radius: 50%;
  box-shadow: 0 0 0.005px #dcd537;
}

.light_box ul.light_top,
.light_box ul.light_bottom {
  width: 100%;
  left: 0;
  padding: 0 0.14rem;
}

.light_box ul.light_top li:nth-child(odd),
.light_box ul.light_bottom li:nth-child(odd) {
  animation: light 0.75s ease infinite;
}

.light_box ul.light_top li:nth-child(even),
.light_box ul.light_bottom li:nth-child(even) {
  animation: light 0.75s ease infinite;
  animation-delay: 0.25s;
}

.light_box ul.light_top {
  top: 0.07rem;
}

.light_box ul.light_bottom {
  bottom: 0.09rem;
}

.light_box ul.light_left,
.light_box ul.light_right {
  flex-direction: column;
  top: 0;
  width: 0.2rem;
  height: 100%;
  padding: 0.34rem 0;
  align-items: center;
}

.light_box ul.light_left li:nth-child(odd),
.light_box ul.light_right li:nth-child(odd) {
  animation: light 0.75s ease infinite;
}

.light_box ul.light_left li:nth-child(even),
.light_box ul.light_right li:nth-child(even) {
  animation: light 0.75s ease infinite;
  animation-delay: 0.25s;
}

.light_box ul.light_left {
  left: 0;
}

.light_box ul.light_right {
  right: 0;
}

@keyframes light {
  0% {
    opacity: 0.5;
    background: #fde466;
  }
  100% {
    opacity: 1;
    background: #fff;
  }
}

.prize_box .play {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  position: relative;
  height: 100%;
}

.prize_box .play li {
  display: block;
  width: 1.56rem;
  height: 1.4rem;
  background: #fff;
  border-radius: 0.1rem;
  border: 1px solid #fffbf2;
  box-shadow: inset 0 0 30px 20px #f1fbef, inset 0 0 1px 1px #fffbf2,
    0 5px 0px 0px transparent, 0 0 10px 5px transparent;
  margin-bottom: 0.16rem;
  position: relative;
}

.prize_box .play li > div {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  position: relative;
}

.prize_box .play li > div.msk {
  position: absolute;
  top: 0;
  width: 1.56rem;
  height: 1.4rem;
  background: #ffdf5d;
  opacity: 0;
}

.prize_box .play li.select > div.msk {
  opacity: 0.7;
}

.prize_box .play li > div > p {
  display: block;
  font-size: 0.24rem;
  font-weight: 600;
  color: #fff;
  text-align: center;
  width: 100%;
  z-index: 9;
  height: 0.6rem;
  line-height: 0.6rem;
  background: linear-gradient(180deg, #3e1b9c00 0%, #3d1b9cb2 100%);
  font-family: Roboto, 'Microsoft Yahei', sans-serif;
  text-shadow: 0.0096rem 0.01rem 0.01rem #000000cc;
}

.prize_box .play li > div span {
  width: 100%;
  height: 0.9rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.prize_box .play li > div.account {
  display: flex;
  align-items: center;
  width: 2.92rem;
  height: 1.41rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 0.1rem;
  border: 1px solid rgb(235 91 63);
}

.prize_box .play li > div.account b {
  display: block;
  text-align: center;
  font-size: 0.24rem;
  color: #fff;
  line-height: 0.4rem;
  width: 100%;
  font-weight: normal;
}

.prize_box .play li > div.account b em {
  color: #ffde5a;
  font-style: normal;
  line-height: 0.3rem;
}

.prize_box .play li > div.account b em.blod {
  font-size: 0.3rem;
  font-weight: bold;
  padding: 0 0.1rem;
}

.prize_box .play li.ex {
  width: unset;
  height: unset;
  background: none;
  border-radius: 0;
  border: none;
  box-shadow: none;
}

#btn {
  display: block;
  width: 3.25rem;
  height: 1.21rem;
  background: url('~@/img/turntable/btn.png') no-repeat center;
  background-size: cover;
  color: #cc0014;
  font-size: 0.44rem;
  font-weight: bold;
  text-align: center;
  margin-top: 0.1rem;
  line-height: 0.9rem;
}

.prize_box .play li.select {
  box-shadow: inset 0 0 0.3rem 0.2rem #ffdf5d, inset 0 0 1px 1px #fffbf2,
    0 0.05rem 0px 0px #410f2b;
}

.prize_box .play li.p-a:nth-child(5) {
  right: 0;
  top: 1.56rem;
}

.prize_box .play li.p-a:nth-child(6) {
  left: 50%;
  top: 1.8rem;
  margin-left: -1.46rem;
}

.prize_box .play li.p-a:nth-child(7) {
  top: 3.12rem;
  right: 0;
}

.prize_box .play li.p-a:nth-child(8) {
  bottom: -0.12rem;
  right: 0;
}

.prize_box .play li.p-a:nth-child(8) img {
  width: 100%;
}

.prize_box .play li.p-a:nth-child(9) {
  top: 54%;
  left: 50%;
  margin-left: -1.625rem;
}

.prize_box .play li.p-a:nth-child(10) {
  bottom: -0.12rem;
  right: 1.63rem;
}

.prize_box .play li.p-a:nth-child(11) {
  bottom: -0.12rem;
  left: 1.63rem;
}

.prize_box .play li.p-a:nth-child(12) {
  left: 0;
  bottom: -0.12rem;
}

.prize_box .play li.p-a:nth-child(12) img {
  width: 100%;
}

.prize_box .play li.p-a:nth-child(13) {
  left: 0;
  top: 3.12rem;
}

.prize_box .play li.p-a:nth-child(14) {
  left: 0;
  top: 1.56rem;
}

.prize_box .play li.p-a:nth-child(14) img {
  width: 100%;
}

.prize_box .play li span img {
  display: block;
  width: 100%;
  position: absolute;
  top: 0;
}

.mask1 {
  display: flex;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  justify-content: center;
  align-items: center;
}

.modal1 {
  width: 5.1rem;
  height: 3.4rem;
  background: url('~@/img/turntable/m_bj.png') no-repeat center;
  background-size: contain;
  position: relative;
}

.modal1 p {
  font-size: 0.3rem;
  line-height: 0.4rem;
  width: 100%;
  display: block;
  text-align: center;
  font-weight: bold;
  color: #333;
}

.close1 {
  display: block;
  width: 0.42rem;
  height: 0.55rem;
  background: url('~@/img/turntable/close.png') no-repeat center;
  background-size: contain;
  position: absolute;
  right: 0;
  top: -0.42rem;
  cursor: pointer;
}

.modal1 .img {
  margin: 0.5rem auto 0.15rem;
  height: 1.2rem;
}

.modal1 .img img {
  display: block;
  margin: 0 auto;
  height: 100%;
}

.win_s {
  width: 5rem;
  height: 1.6rem;
  background: url('~@/img/turntable/win_s.png') no-repeat center;
  background-size: contain;
  line-height: 0.25rem;
  color: #59a9f3;
  padding: 0.24rem 0.2rem 0;
  position: absolute;
  bottom: -1.5rem;
  left: 0.05rem;
  text-align: center;
  font-size: 0.2rem;
}

.rules {
  width: 7rem;
  margin: 0 auto;
  color: #fdfcf3;
}

.rules h2 {
  font-size: 0.28rem;
  line-height: 0.66rem;
  color: #fdfcf3;
}

.rules .tj {
  width: 6.8rem;
  border-radius: 0.16rem;
  border: 0.02rem solid #fdfcf3;
  margin: 0 auto;
}

.rules .tj p {
  line-height: 0.47rem;
  text-align: center;
  font-size: 0.28rem;
  color: #fdfcf3;
  background: rgba(255, 255, 255, 20%);
  font-weight: bold;
}

.rules .tj p:first-child {
  border-bottom: 0.02rem solid #ffffff66;
}

.rules .rule {
  line-height: 0.42rem;
  font-size: 0.24rem;
}

.rulesbox {
  width: 7.2rem;
  margin: 0 auto;
  padding: 0.1rem;
  border-radius: 0.2rem;
  background: linear-gradient(164.05deg, #4547ff 0%, #b423ce 100%);
  box-shadow: inset 0px 0px 0.4rem 0px rgba(252, 252, 252, 0.11);
}

.rulesbox .c {
  font-size: 0.28rem !important;
  color: #fdfcf3;
  line-height: 0.46rem;
}

.rulesbox .c span {
  font-size: 0.24rem !important;
}

.rulesbox h1 {
  font-size: 0.48rem;
  color: #fdfcf3;
  text-align: center;
  line-height: 0.9rem;
}
</style>
